import { Component, OnInit, EventEmitter, Input, Output, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';
import { RepoBusinessFacade } from '../../shared-new/store/repo-business/repo-business.facade';
import { takeUntil } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { Position, RepoBusiness, RepoContact } from '../../models/repo-business/repo-business.model';
import { SearchCountryField, CountryISO, PhoneNumberFormat, NgxIntlTelInputComponent } from 'ngx-intl-tel-input';
import Constants from 'src/app/constants.json';
import { Country } from 'ngx-intl-tel-input/lib/model/country.model';

@Component({
  selector: 'app-repocontact-edit',
  templateUrl: './repocontact-edit.component.html',
  styleUrls: ['./repocontact-edit.component.scss']
})
export class RepocontactEditComponent extends BaseUnsubscribeComponent implements OnInit, AfterViewInit {
  success$ = this.repoBusinessFacade.success$;
  positions$ = this.repoBusinessFacade.positions$;
  repoBusinesses$ = this.repoBusinessFacade.repoBusinesses$;
  contactForm: FormGroup;
  private _contact: RepoContact;
  @Input() public set contact(value: RepoContact) {
    this._contact = value;
    this.onInit();
  }
  public get contact(): RepoContact {
    return this._contact;
  }
  @Input() public isShowOrgDropDown: boolean = false;
  @Input() public isShowRepoMailCheckboxes: boolean = false;
  private selectedContactId: number = 0;
  public selectedBusinessId: number = 0;
  positionList: Position[];
  public countries: any[] = [];
  salutations: string[] = ['Dr', 'Mr', 'Mrs', 'Miss', 'Ms', 'Master', 'Madam'];
  @Output() contactSaved = new EventEmitter<RepoContact>();
  @Output() contactValidationFailed = new EventEmitter<RepoContact>();
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  selectedCountryISO: CountryISO;
  preferredCountries: CountryISO[] = Constants.preferredCountries.map((item) => item as CountryISO);
  @Input() public isUSA = false;
  @ViewChild('phoneInput') phoneInput: NgxIntlTelInputComponent;
  public repoBusinesses: RepoBusiness[];

 
  constructor(private readonly repoBusinessFacade: RepoBusinessFacade,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private readonly commonService: CommonService,
    private readonly toastService: ToastService) {
    super();
  }

  public get OrgTitle(): string {
    return this.isUSA ? 'Organization' : 'Organisation';
  }
 
  private resetPhone() {
    if (this.phoneInput) {
      this.phoneInput.value = '';
      this.phoneInput.phoneNumber = '';
      this.phoneInput.selectedCountry = { flagClass: '', dialCode: '', iso2: '' } as Country;
      this.phoneInput.countrySearchText = '';

      // Refresh placeholder if needed
      this.phoneInput.customPlaceholder = '';


      // Force re-validation
      this.phoneInput.onPhoneNumberChange();
    }
  }
  ngAfterViewInit() {
    const flagContainer = document.querySelector('.iti__flag-container');
    if (flagContainer) {
      flagContainer.addEventListener('click', () => {
        this.phoneInput.searchCountry();
      });
    }
  }

  private onInit() {
    this.selectedContactId = this.contact?.repoContactId ?? 0;
    this.selectedBusinessId = this.contact?.repoBusiness?.repoBusinessId ?? 0;
    this.setDefaultCountryFromDialCode(this.contact?.countryCode);
    this.contactForm = RepoContact.asFormGroup(this.contact);
    if (this.phoneInput) {
      if (this.selectedContactId === 0) {
        this.resetPhone();

      } else {
        // ✳️ Existing contact → set selected flag based on saved countryCode
        const country = this.phoneInput.allCountries?.find(
          c => c.dialCode === (this.contact?.countryCode?.replace('+', '') || '')
        );

        if (country) {
          this.phoneInput.selectedCountry = country;
          this.phoneInput.value = this.contact?.mobile
            ? this.contact.countryCode + this.contact.mobile
            : '';
          this.phoneInput.phoneNumber = this.phoneInput.value;
          this.phoneInput.countrySearchText = '';
        } else {
          this.resetPhone();
        }
      }
    }

    this.contactForm.valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(val => {
        val["mobile"] = val?.phone?.internationalNumber.replace(val?.phone?.dialCode, '');
        val["countryCode"] = val?.phone?.dialCode;

        Object.assign(
          this.contact,
          RepoContact.asObject(val, this.selectedContactId, this.selectedBusinessId)
        );
      });
  }
  ngOnInit(): void {
    this.onInit();
    this.attachEvents();
  }
  private attachEvents(): void {
    this.success$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      if (response?.saveRepoContact) {
        this.toastService.success('Contact Saved', 'Success!');
        if (this.isShowOrgDropDown) {
          this.repoBusinessFacade.loadContacts();
        } else {
          this.repoBusinessFacade.loadContactsByRepoBusinessId(this.selectedBusinessId);
        }
        this.repoBusinessFacade.loadRepoBusinesses();
        this.contactSaved.emit(this.contact);
      }
    });

    this.repoBusinesses$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((business) => {
        if (business == null) {
          this.repoBusinessFacade.loadRepoBusinesses();
        }
        this.repoBusinesses = business;
      });

    this.positions$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((positions) => {
        if (positions == null) {
          this.repoBusinessFacade.loadPositions();
        }
        this.positionList = positions;
      });

    this.commonService.getCountries().subscribe((response) => {
      if (response.body) {
        const responseData = JSON.parse(JSON.stringify(response.body));
        if (responseData) {
          this.countries = responseData;

          if (this.countries && this.countries?.length > 0) {
          }
        }
      }
    });
  }
  setDefaultCountryFromDialCode(code: string) {
    if (code) {
      const dialCode = code.replace('+', '');
      const matched = (window as any).intlTelInputGlobals.getCountryData().find((c: any) => c.dialCode === dialCode);

      if (matched) {
        this.selectedCountryISO = matched.iso2.toUpperCase() as CountryISO;
      }
    }
  }
  public getFormData(): RepoContact {
    if (this.contactForm.invalid) {
      for (var i in this.contactForm.controls) {
        this.contactForm.controls[i].markAsTouched();
      }
      this.contactValidationFailed.emit(this.contact);
      return null;
    }
    if (this.contactForm) {
      const formData = this.contactForm.value;
      formData["mobile"] = formData.phone?.internationalNumber?.replace(formData.phone?.dialCode ?? '', '');
      formData["countryCode"] = formData.phone?.dialCode;
      const contact = RepoContact.asObject(
        formData,
        this.selectedContactId,
        this.selectedBusinessId
      );
      return contact;
    }
    return null;
  }
  public submitForm(): void {
    const contact = this.getFormData();
    if (!contact) {
      return;
    }
    this.repoBusinessFacade.saveRepoContact(contact);
  }
}
